export default function getOperation(user, stNumTelefone, idFunctionality, stAction, stIntegrity, stProtocol, stObs) {
  if (user) {

    var segment = "";

    switch(user.customerSegment) {
      case "CORPORATE":
        segment = "CORPORATIVO";
        break;
      case "RESIDENTIAL":
        segment = "RESIDENCIAL";
        break;
      case "BUSINESS":
        segment = "EMPRESARIAL";
        break;
      default:
        segment = user.customerSegment;
        break;
    }

    return {
      "numCnpjCpf": user.documentNumber,
      "numTelefone": stNumTelefone,
      "idFunctionality": idFunctionality,
      "idAction": stAction,
      "stProtocol": stProtocol,
      "stIntegrity": stIntegrity,
      "customerId": user.customerId,
      "stSegment": segment,
      "stObs": stObs,
      "stSourceSystem": "PORTALB2B"
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/utils/operationExperience.js